<template>
  <div>
    <b-row class="pl-5">
      <b-col>
        <ul>
          <li>
            <a
              href="#"
              @click.prevent="state = 'RECEIPTS'"
              v-bind:class="{ active: state == 'RECEIPTS' }"
              ><i class="fal fa-receipt"></i>Receipts</a
            >
          </li>
          <li
            v-if="
              hasRole('CREATEPAYMENTPLANS') ||
                hasRole('EDITPAYMENTPLANS') ||
                hasRole('VIEWPAYMENTPLANS')
            "
          >
            <a
              href="#"
              @click.prevent="state = 'PAYMENTPLAN'"
              v-bind:class="{ active: state == 'PAYMENTPLAN' }"
              ><i class="fal fa-calendar-day"></i>Payment Plans</a
            >
          </li>
          <li
            v-if="
              hasRole('CREATEMEMBERSHIPS') ||
                hasRole('EDITMEMBERSHIPS') ||
                hasRole('VIEWMEMBERSHIPS')
            "
          >
            <a
              href="#"
              @click.prevent="state = 'MEMBERSHIP'"
              v-bind:class="{ active: state == 'MEMBERSHIP' }"
              ><i class="fal fa-user-circle"></i>Memberships</a
            >
          </li>

          <li>
            <a
              href="#"
              @click.prevent="state = 'PAYMENTPAGE'"
              v-bind:class="{ active: state == 'PAYMENTPAGE' }"
              ><i class="fal fa-browser"></i>Payment Page</a
            >
          </li>
          <li v-if="hasRole('BETA')">
            <a
              href="#"
              v-bind:class="{ active: state == 'APPOINTMENTS' }"
              @click.prevent="state = 'APPOINTMENTS'"
              ><i class="fal fa-desktop-alt"></i>Appointments</a
            >
          </li>
        </ul>
      </b-col>
    </b-row>
    <b-row class="p-5">
      <b-col>
        <receipt-settings
          v-if="state == 'RECEIPTS'"
          :company="company"
          :bindReceiptSettings="bindReceiptSettings"
          @updateReceiptSettings="updateReceiptSettings"
        ></receipt-settings>

        <payment-plan-settings
          v-if="state == 'PAYMENTPLAN'"
          :company="company"
          @updatePaymentPlanSettings="updatePaymentPlanSettings"
          :bindPaymentPlanSettings="bindPaymentPlanSettings"
        ></payment-plan-settings>

        <membership-settings
          v-if="state == 'MEMBERSHIP'"
          :company="company"
          :bindMembershipSettings="bindMembershipSettings"
          @updateMembershipSettings="updateMembershipSettings"
        ></membership-settings>

        <payment-page-settings
          v-if="state == 'PAYMENTPAGE'"
          :company="company"
          :updatePaymentPageSettings="updatePaymentPageSettings"
          :bindPaymentPageSettings="bindPaymentPageSettings"
          :sendPaymentPageEmail="sendPaymentPageEmail"
        ></payment-page-settings>

        <appt-settings
          v-if="state == 'APPOINTMENTS'"
          :company="company"
          @updateApptSettings="updateApptSettings"
          :bindApptSettings="bindApptSettings"
        ></appt-settings>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ReceiptSettings from "@/views/Components/Company/ReceiptSettings";
import MembershipSettings from "@/views/Components/Company/MembershipSettings";
import PaymentPlanSettings from "@/views/Components/Company/PaymentPlanSettings";
import ApptSettings from "@/views/Components/Company/ApptSettings";

import PaymentPageSettings from "@/views/Components/Company/PaymentPageSettings";

export default {
  components: {
    "receipt-settings": ReceiptSettings,
    "payment-plan-settings": PaymentPlanSettings,
    "membership-settings": MembershipSettings,
    "appt-settings": ApptSettings,
    "payment-page-settings": PaymentPageSettings,
  },
  data() {
    return {
      state: "RECEIPTS",
      options: [
        { text: "Receipts", value: "RECEIPTS" },
        { text: "Payment Plans", value: "PAYMENTPLAN" },
        { text: "Memberships", value: "MEMBERSHIP" },
      ],
    };
  },
  inject: ["hasRole"],
  props: {
    company: null,
    bindApptSettings: null,
    bindMembershipSettings: null,
    bindReceiptSettings: null,
    bindPaymentPageSettings: null,
    bindPaymentPlanSettings: null,
    sendPaymentPageEmail: null,
    updatePaymentPageSettings: null,
  },
  methods: {
    updateReceiptSettings(t) {
      this.$emit("updateReceiptSettings", t);
    },
    updateMembershipSettings(t) {
      this.$emit("updateMembershipSettings", t);
    },
    updatePaymentPlanSettings(t) {
      this.$emit("updatePaymentPlanSettings", t);
    },
    updateApptSettings(t) {
      this.$emit("updateApptSettings", t);
    },
  },
};
</script>

<style scoped>
ul,
li {
  margin: 0;
  padding: 0;
  line-height: 1;
}

ul li {
  list-style-type: none;
  line-height: 1;
  display: inline-block;
  padding-right: 55px;
}

ul li a {
  border-bottom: solid 4px transparent;
  padding-bottom: 8px;
  display: block;
  color: #525f7f;
  font-weight: 600;
  font-size: 0.9em;
  text-align: center;
  -webkit-transition: all 600ms ease;
  -moz-transition: all 600ms ease;
  -ms-transition: all 600ms ease;
  -o-transition: all 600ms ease;
  transition: all 600ms ease;
}

ul li a:hover,
ul li a.active {
  border-bottom: solid 4px #4693ce;
  color: #4693ce;
}

ul li a i.fal,
ul li a i.fak {
  display: block;
  font-size: 1.8em;
  padding-bottom: 10px;
}
</style>
